export function routeLocale(url) {
    var currentLocale = $('meta[name="locale"]').attr('content');
    if (currentLocale == 'pt_BR') {
        return url;
    }

    if (url.indexOf('api/') > -1) {
        return url.replace('api/', 'api/' + currentLocale + '/');
    }

    return currentLocale + '/' + url;
}
